<template>
    <div class="md-layout md-gutter">
        <div class="md-layout-item flex-center">
            <div style="flex: 2">{{ settingName }}</div>
        </div>
        <div class="md-layout-item">
            <md-field>
                <label for="setting">{{ initialValue }}</label>
                <md-select
                    v-model="value"
                    name="setting"
                    id="setting"
                    style="flex: 2"
                >
                    <md-option
                        v-for="option in possibleValues"
                        :key="option"
                        :value="option"
                        >{{ option }}</md-option
                    >
                </md-select>
            </md-field>
        </div>
        <div class="md-layout-item flex-center">
            <md-button
                class="md-raised md-primary"
                style="flex: 1"
                :disabled="updating || this.value == this.initialValue"
                @click="updateSetting"
            >
                Update
            </md-button>
        </div>
        <div
            class="md-layout-item"
            style="display: flex; flex: revert; align-items: center"
        >
            <!-- Icon with tooltip -->
            <md-button class="md-icon-button" @click="help = true">
                <md-icon>help</md-icon>
            </md-button>
        </div>

        <md-dialog-alert
            :md-active.sync="help"
            :md-content="description.replace(/\n/g, '<br>')"
            md-confirm-text="Close"
        />
    </div>
</template>

<script>
import axiosMixin from "../mixins/axiosMixin";
export default {
    mixins: [axiosMixin],
    props: {
        initialValue: {
            type: String,
            default: "",
        },
        settingName: String,
        settingType: String,
        settingEndpoint: String,
        possibleValues: Array,
        description: String,
    },
    watch: {
        initialValue() {
            this.value = this.initialValue;
        },
    },
    data() {
        return {
            value: this.initialValue,
            updating: false,
            help: false,
        };
    },
    methods: {
        updateSetting() {
            if (
                !this.value ||
                this.value == this.initialValue ||
                !this.settingEndpoint
            )
                return;
            this.updating = true;
            this.makeRequest(
                "put",
                process.env.VUE_APP_SERVER_URL +
                    "settings/" +
                    this.settingEndpoint,
                { value: this.value }
            ).then((resp) => {
                this.updating = false;
                if (resp.status == 200) {
                    this.$emit("updatedSetting");
                }
            });
        },
    },
};
</script>

<style>
</style>